// Formatação comum do backoffice (datas na língua ativa) e pequenos hooks.
import { intlLocale } from "@ecliptica/i18n";
import { useEffect, useState } from "react";

/** Data (e hora) no formato da língua ATIVA (`lang` = i18n.language; um "pt-PT" com o PT inativo formata em inglês). */
export function formatDate(d: string | Date | null | undefined, lang: string, withTime = true): string {
  if (!d) return "—";
  return new Intl.DateTimeFormat(intlLocale(lang), withTime ? { dateStyle: "short", timeStyle: "short" } : { dateStyle: "medium" }).format(new Date(d));
}

/** Valor que só muda depois de o utilizador parar de escrever (pesquisa sem um pedido por tecla). */
export function useDebounced<T>(value: T, ms = 300): T {
  const [v, setV] = useState(value);
  useEffect(() => {
    const id = setTimeout(() => setV(value), ms);
    return () => clearTimeout(id);
  }, [value, ms]);
  return v;
}
